import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-loading-dialog',
    templateUrl: './loading-dialog.component.html',
    styleUrls: ['./loading-dialog.component.css'],
    standalone: false,
})
export class LoadingDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { progress: number; title: string; text: string }
    ) {}
}
